import React from 'react';
import { StyleSheet, View } from 'react-native';
import { AppSidebar } from '@kiips/ui';
import { useUnifiedSidebar } from '../contexts/UnifiedSidebarContext';
import { useSidebarContent } from '../contexts/SidebarContentContext';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Renders all sidebars (menu, edit, panel) at the top level.
 * Content is provided by MenuContext and screens via SidebarContentContext.
 * All sidebars overlay the entire app and block interactions until closed.
 */
export function GlobalSidebarHost() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const { activeSidebar, close: closeSidebar } = useUnifiedSidebar();
  const {
    menuContent,
    menuOnClose,
    setMenu,
    editContent,
    editOnClose,
    setEdit,
    panelContent,
    panelOnClose,
    setPanel,
  } = useSidebarContent();

  const handleMenuClose = () => {
    menuOnClose?.();
    closeSidebar();
    setMenu(null, undefined);
  };

  const handleEditClose = () => {
    editOnClose?.();
    closeSidebar();
    setEdit(null, undefined);
  };

  const handlePanelClose = () => {
    panelOnClose?.();
    closeSidebar();
    setPanel(null, undefined);
  };

  return (
    <View style={[StyleSheet.absoluteFill, { zIndex: 100 }]} pointerEvents="box-none">
      {activeSidebar === 'menu' && menuContent ? <AppSidebar open onClose={handleMenuClose} isDark={isDark}>
          {menuContent}
        </AppSidebar> : null}
      {activeSidebar === 'edit' && editContent ? <AppSidebar open onClose={handleEditClose} isDark={isDark}>
          {editContent}
        </AppSidebar> : null}
      {activeSidebar === 'panel' && panelContent ? <AppSidebar open onClose={handlePanelClose} isDark={isDark}>
          {panelContent}
        </AppSidebar> : null}
    </View>
  );
}
